import { render, staticRenderFns } from "./OrnamentHistory.vue?vue&type=template&id=d92d8b0a&scoped=true&"
import script from "./OrnamentHistory.vue?vue&type=script&lang=js&"
export * from "./OrnamentHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrnamentHistory.vue?vue&type=style&index=0&id=d92d8b0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92d8b0a",
  null
  
)

export default component.exports